(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-hangover-ref"] && !Shopify.designMode) return;
  try {
    
function hfMq(id, items){
  var el = document.getElementById(id);
  if (!el) return;
  var half = items.join('');
  el.innerHTML = half + half;
}

function hfHangoverInit() {
  var ratingTicker = document.querySelector('.hf-ticker-rating');
  var ratingHtml = ratingTicker
    ? ratingTicker.outerHTML.replace(/\s*id="hfTickerRating"/, '')
    : '<i class="hf-ticker-rating">★ 4.8 / 5 VERIFIED</i>';
  hfMq('hfMqTop', [
    '<i>LAST CALL — <b>30% OFF</b> ENDS TONIGHT</i>',
    '<i>FREE SHIPPING ON 3 &amp; 6 PACKS</i>',
    '<i><b>COD</b> AVAILABLE</i>',
    '<i>100% NATURAL · VEGAN</i>',
    '<i>FOUNDED BY A NUTRITIONIST</i>',
    ratingHtml
  ]);
  hfMq('hfMqBig', [
    '<i>drink tonight</i>',
    '<i class="solid">function tomorrow</i>',
    '<i>drink tonight</i>',
    '<i class="solid">function tomorrow</i>'
  ]);

  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  },{threshold:0.15});
  document.querySelectorAll('.hf-rv,.hf-log-row').forEach(function(el){io.observe(el);});

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hfHangoverInit);
} else {
  hfHangoverInit();
}

  } catch(e) { console.error(e); }
})();
})();
